import { connectCurrentRefinements } from 'instantsearch.js/es/connectors';

// Create the render function
const createDataAttribtues = (refinement) => Object.keys(refinement)
    .map((key) => `data-${key}="${refinement[key]}"`)
    .join(' ');

const renderListItem = (item) => `
    ${item.refinements.map((refinement) => `
        <button ${createDataAttribtues(refinement)} class="c-btn is-sm">X&nbsp; ${(item.label === 'product' ? refinement.label.split('||')[0] : refinement.label)}</button>
    `).join('')}`;

const renderCurrentRefinements = (renderOptions) => {
    const {
        items,
        refine,
        widgetParams,
    } = renderOptions;

    widgetParams.container.innerHTML = `${items.length > 0 ? '<span class="c-title-supporting u-type-xs">Selected filters:</span>' : ''}${items.map(renderListItem).join('')}`;

    [...widgetParams.container.querySelectorAll('button')].forEach((element) => {
        element.addEventListener('click', (event) => {
            const item = Object.keys(event.currentTarget.dataset).reduce((acc, key) => ({
                ...acc,
                [key]: event.currentTarget.dataset[key],
            }), {});

            refine(item);
        });
    });
};

// Create the custom widget
const customCurrentRefinements = connectCurrentRefinements(
    renderCurrentRefinements,
);

export default customCurrentRefinements;
